import { render, staticRenderFns } from "./bundlingModal.vue?vue&type=template&id=28af815c"
import script from "./bundlingModal.vue?vue&type=script&lang=js"
export * from "./bundlingModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28af815c')) {
      api.createRecord('28af815c', component.options)
    } else {
      api.reload('28af815c', component.options)
    }
    module.hot.accept("./bundlingModal.vue?vue&type=template&id=28af815c", function () {
      api.rerender('28af815c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/productmanager/productDetail/bundlingModal.vue"
export default component.exports